import React, { useEffect, useState } from 'react'
// import EstablishmentStatistics from './statistics/EstablishmentStatistics'
import ListEventItems from './ListEventItems'
import eventsApi from 'api/requests/events'
import Modal from 'components/_UI/Modal'
import EventForm from 'modules/events/form/EventForm'
import Loader from 'components/_UI/Loader'
import styled, { keyframes } from 'styled-components'
import EventListSkeleton from 'components/commons/skeletons/EventListSkeleton'
import DashCollapse from 'components/_UI/DashCollapse'
import { useDetailVisible } from 'context/dash/DetailVisible'
import Tab from '../_common/Tab'
import EventDetail from './detail/general/EventDetail'
import { Column } from 'styled/alignment/Column'
import DeleteEvent from './delete/DeleteEvent'
import { useContainerClick } from 'context/dash/ContainerClick'
import { useShowAllEvents } from 'context/dash/ShowAllEvents'
import Text from 'components/_UI/Text'
import EventItem from './EventItem'
import { useEventDetailTab } from 'context/dash/EventDetailTab'
import { FullyCentered } from 'styled/alignment/Center'
import colors from 'theme/colors'
import ShowMoreList from './ShowMoreList'
import TicketDetail from './detail/tickets/detail/TicketDetail'
import { useSearchParams } from "react-router-dom";
import routeParams from 'theme/routeParams'
import ParticipantsList from './detail/participants/ParticipantsList'
import TicketForm from './tickets/TicketForm'
import { Row } from 'styled/alignment/Row'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import paths from 'routes/paths'
import { useEvent } from 'context/events/Event'
import { useUser } from 'context/user/User'
import usePanelPermissions from 'hooks/usePanelPermissions'
import { isEventCollaboratorOnly } from 'helpers/dashboardAccess'
import { PERMISSIONS } from 'helpers/panelPermissions'
import { EVENT_PERMISSIONS, canInEvent, isCollaboration, tabRestriction } from 'helpers/eventCollaboration'
import { hasEventEnded } from 'helpers/eventEnded'
import CollaborationNotice from './collaboration/CollaborationNotice'
import RestrictedPage from './collaboration/RestrictedPage'
import Button from 'components/_UI/Button'
import ProductsToEvent from './form/ProductsToEvent'
import EventCustomFieldsStep from './form/EventCustomFieldsStep'
import useToast from 'hooks/useToast';
import ToastContainer from 'components/_UI/ToastsContainer';
import ProductDetail from './detail/products/detail/ProductDetail'
import productsApi from 'api/requests/products'
import RichTextEditor from 'components/commons/RichText'
import CollaboratorsPermissions from './detail/permissions/CollaboratorsPermissions'
import PromotionalCodes from './detail/promotionalCodes/PromotionalCodes'
import Additional from './detail/additional/Additional'
import PublishModal from './form/PublishModal'
import EventOrders from './detail/orders/EventOrders'
import Expenses from './detail/expenses/Expenses'


import BankForm from '../financial/bank-form/BankForm'
import producerProfiles from 'api/requests/producerProfiles'

export default function MainContent({ createEventClick, createDraftClick, setCreateDraftClick }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const showCreate = searchParams.get(routeParams.resume.create);
    const showDetail = searchParams.get(routeParams.resume.detail);
    const editProductsSlug = searchParams.get(routeParams.resume.editProducts);
    const highlightProductId = searchParams.get(routeParams.resume.highlightProduct);
    const { toast, toasts } = useToast()


    const { containerClick } = useContainerClick();
    const { detailVisible, setDetailVisible } = useDetailVisible();
    const { showAllEvents, setShowAllEvents } = useShowAllEvents();
    const { eventDetailTab, setEventDetailTab } = useEventDetailTab();

    const { event, setEvent } = useEvent();
    const { user } = useUser();
    const { can } = usePanelPermissions();
    const canCreateEvents = can(PERMISSIONS.EVENTS_CREATE);

    const [eventLoading, setEventLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isCreate, setIsCreate] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [eventActionError, setEventActionError] = useState(false);
    const [data, setData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [withBackButton, setWithBackButton] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [formStep, setFormStep] = useState(1);
    const [noEstablishmentModal, setNoEstablishmentModal] = useState(false);
    const [showBankForm, setShowBankForm] = useState(false);
    const [hasTickets, setHasTickets] = useState(null);
    const [hasProducts, setHasProducts] = useState(false);
    const [originEvent, setOriginEvent] = useState();
    const [dropdownLoading, setDropdownLoading] = useState();
    const [productsLoading, setProductsLoading] = useState();
    const [availableProducts, setAvailableProducts] = useState();
    const [hasProfileProducer, setHasProfileProducer] = useState(true);
    const [productsPagination, setProductsPagination] = useState({
        lastPage: null,
        perPage: null,
        currentPage: null,
        totalItems: null,
    });
    const [publishModal, setPublishModal] = useState(false);
    const [collaborationEditNotice, setCollaborationEditNotice] = useState(false);


    useEffect(async () => {
        if (showDetail) {
            renderDetail(showDetail)
        }

        // Entrada vinda de outra tela (aba "A venda em eventos" da página de
        // Produtos): abre direto o evento certo, já no step de produtos, como
        // se o produtor tivesse clicado "editar" e navegado até aqui sozinho.
        if (editProductsSlug && user) {
            await getEventBySlug({ slug: editProductsSlug, from: true });
            // getEventBySlug sozinho não seta isso — sem ele, o step de
            // produtos assume que é um evento novo e o salvar não envia os
            // produtos que já existem, só os rascunhos criados nesta sessão.
            setOriginEvent('edit');
            setFormStep(3);
        }

        if (showCreate == 1 && user && canCreateEvents) {
            if (!user?.has_bank_account) {
                setShowBankForm(true);
            } else {
                setIsCreate(true)
            }
        }

        if ((createEventClick || createDraftClick) && user && canCreateEvents) {
            if (!user?.has_bank_account) {
                setShowBankForm(true);
            } else {
                setIsCreate(true)
            }
            return
        }

        if (user) {
            // Os modelos de produto só servem para criar evento: quem foi convidado
            // só para eventos não os tem (e a rota é de papel de painel).
            await Promise.all([getEvents(), isEventCollaboratorOnly(user) ? null : getAvailableProducts()])
        }

    }, [createEventClick, createDraftClick, user, showCreate, showDetail, editProductsSlug])

    const handleTabClick = (eventDetailTab) => {
        setEventDetailTab(eventDetailTab)
    };


    async function getProfileProducer() {
        try {
            const { data } = await producerProfiles.me();

            setHasProfileProducer(data?.data);
            console.log(data?.data)
        } catch ({ response }) {

            if (response?.status == 404) {
                setHasProfileProducer(false);
                return
            }
        }
    }

    function createEvent() {
        if (!user?.has_bank_account) {
            setShowBankForm(true);
        }
        const isEstablishment = user?.role?.id == import.meta.env.VITE_ESTABLISHMENT_ROLE_ID
        const isProducer = user?.role?.id == import.meta.env.VITE_PRODUCER_ROLE_ID

        if (isProducer) {
            getProfileProducer()
        }

        if (isEstablishment && !user?.establishments.length) {
            setNoEstablishmentModal(true);
            return;
        }

        setEvent(null)
        setIsCreate(true)
    }


    function renderContent(tabName) {
        // Evento em colaboração: a página que o convite não libera vira um aviso.
        const restriction = tabRestriction(detailVisible, tabName);

        if (restriction) {
            return (
                <ContentDash>
                    <RestrictedPage needs={restriction.needs} />
                </ContentDash>
            );
        }

        return (

            <>
                {/* {tabName === 'statistics' && <ContentDash><h2>Estatísticas</h2></ContentDash>} */}
                {tabName === 'detail' &&
                    <ContentDash>
                        <EventDetail
                            item={showDetail ? showDetail : detailVisible?.slug}
                            setHasTickets={setHasTickets}
                            hasTickets={hasTickets}
                            withBackButton={withBackButton}
                            setHasProducts={setHasProducts}
                            hasProducts={hasProducts}
                        />
                    </ContentDash>}

                {tabName === 'tickets' && (
                    hasTickets ? (

                        <ContentDash>
                            <TicketDetail data={showDetail ? showDetail : detailVisible.slug} />
                        </ContentDash>
                    ) : (
                        <ContentDash notResult>
                            <NotResultDashBoard
                                text={
                                    <>
                                        <Text>Você ainda não possui ingressos criados pra esse evento.</Text>
                                        <Text>Gostaria de criar?</Text>
                                    </>
                                }
                                textButton={'Criar Ingresso'}
                                onClick={() => activeActionClicked({ action: 'create-ticket', slug: detailVisible.slug })}
                                ilustration={'up-graphic'}
                            />
                        </ContentDash>
                    ))}

                {tabName === 'products' && (
                    hasProducts ? (
                        <ContentDash>
                            <ProductDetail data={showDetail ? showDetail : detailVisible.slug} />
                        </ContentDash>
                    ) : (
                        <ContentDash notResult>
                            <NotResultDashBoard
                                text={
                                    <>
                                        <Text>Você ainda não possui produtos criados para esse evento.</Text>
                                        <Text>Gostaria de criar?</Text>
                                    </>
                                }
                                textButton={'Criar Produto'}
                                onClick={() => activeActionClicked({ action: 'create-product', slug: detailVisible.slug })}
                                ilustration={'stock'}
                            />

                        </ContentDash>
                    )
                )}
                {tabName === 'participant' &&
                    <ContentDash>
                        <ParticipantsList data={showDetail ? showDetail : detailVisible.slug} />
                    </ContentDash>
                }
                {tabName === 'permissions' &&
                    <ContentDash>
                        <CollaboratorsPermissions data={showDetail ? showDetail : detailVisible.slug} />
                    </ContentDash>
                }
                {tabName === 'promotionalCode' &&
                    <ContentDash>
                        <PromotionalCodes data={showDetail ? showDetail : detailVisible.slug} />
                    </ContentDash>
                }
                {tabName === 'additional' &&
                    <ContentDash>
                        <Additional data={showDetail ? showDetail : detailVisible.slug} />
                    </ContentDash>
                }
                {tabName === 'orders' &&
                    <ContentDash>
                        <EventOrders data={showDetail ? showDetail : detailVisible.slug} />
                    </ContentDash>
                }
                {tabName === 'expenses' &&
                    <ContentDash>
                        <Expenses />
                    </ContentDash>
                }
            </>
        );

    }

    async function getEvents() {
        setLoading(true)
        try {
            const { data } = await eventsApi.myEvents()
            setData(data?.data)

            setLoading(false)

            if (!data?.now?.total > 0 || !data?.next?.total > 0 || !data?.expired?.total > 0) {
                setNotFound(true)
            }
        } catch (error) {
            console.log('error')
        } finally {
            setLoading(false)
        }
    }


    function handleSucess() {
        getEvents()
        toast.success('Evento excluido com sucesso', {
            position: 'top-center'
        })
    }

    // Evento que já aconteceu não se edita: o item da lista traz as datas e, quando
    // o detalhe abriu só pelo slug, vale o evento carregado no contexto.
    const detailEvent = typeof detailVisible === 'object' ? detailVisible : (event?.slug === detailVisible ? event : null);
    const detailEnded = hasEventEnded(detailEvent);

    function renderDetail(slug) {
        renderContent('detail')
        setDetailVisible(slug)
    }

    async function getEventBySlug(item) {

        if (item.from) {
            setEventLoading(true)
        } else {
            setDropdownLoading(true);
        }

        try {
            const { data } = await eventsApi.getBySlug(item.slug)
            setEvent(data?.data)
            setIsEdit(data?.data)
            return data?.data
        } catch (error) {
            console.log('error')
        } finally {
            setDropdownLoading(false);
            setTimeout(() => {
                setEventLoading(false)
            }, 400);
        }
    }

    function activeActionClicked(item) {
        // Evento de outro produtor: a edição completa pela web não existe para
        // colaborador, só o aviso (o mesmo da tela de colaborador).
        if (item.action === 'edit' && isCollaboration(item)) {
            setCollaborationEditNotice(true);
            return;
        }

        setDetailVisible(false)
        setIsCreate(false)

        if (item.action === 'edit') {
            getEventBySlug({ slug: item?.slug, from: item.from });
            setFormStep(1);

            return
        }

        if (item.action === 'create-product') {
            getEventBySlug({ slug: item?.slug });
            setFormStep(3);
            return
        }
        if (item.action === 'create-ticket') {
            getEventBySlug({ slug: item?.slug });
            setFormStep(2);
            return
        }

        if (item.action === 'additional-fields') {
            getEventBySlug({ slug: item?.slug });
            setFormStep(4);
            return
        }

        if (item.action === 'delete') {
            setIsDelete(item);
        }

        if (item.action === 'publish') {
            setPublishModal(item);
        }
    }

    async function getAvailableProducts(page = 1) {
        if (!!availableProducts && productsPagination.currentPage === page) {
            return
        }

        setProductsLoading(true);

        try {
            const { data } = await productsApi.get({ page });
            const productsWithFlag = data?.data.map(el => ({ ...el, is_template: true }))
            setAvailableProducts(productsWithFlag);
            setProductsPagination({
                lastPage: data?.meta?.last_page,
                perPage: data?.meta?.per_page,
                currentPage: data?.meta?.current_page,
                totalItems: data?.meta?.total,
            });

        } catch (error) {
            setAvailableProducts(false);
        } finally {
            setProductsLoading(false);
        }
    }

    function onProductPaginate(page = 1) {
        getAvailableProducts(page);
    }

    async function onEventSucces(data, from) {

        const isEdit = from === 'edit';
        const withTickets = data?.products?.filter(el => el.type === 'ticket')

        setOriginEvent(from)

        getEvents()

        if (isEdit) {

            if (withTickets?.length || data?.has_tickets) {
                setFormStep(2);
                return
            }

            // No tickets to configure — always offer the products step next,
            // even with zero templates yet: it's the only place a producer can
            // create a brand-new product for this event without leaving the wizard.
            if (!withTickets?.length && !data?.has_tickets) {
                setDetailVisible(false);
                setFormStep(3);
                return
            }
        }

        if (data?.has_tickets) {
            setFormStep(2);
            return
        }

        if (!withTickets?.length && !data?.has_tickets) {
            setDetailVisible(false);
            setFormStep(3);
            return
        }


        setIsCreate(false);
        setIsEdit(false);
        setDetailVisible(data);
        setFormStep(0);
        // getEvents();
    }

    async function onTicketSuccess() {
        // Refetch so the products step reads the freshly-saved absorbed-service-fee
        // value. Without this, ProductsToEvent sources it from the stale event snapshot
        // and saves products with the pre-toggle value, so the change only "takes" on a
        // second edit (after the event is refetched on re-entry).
        await getEventBySlug({ slug: event?.slug, from: true });
        // Campos adicionais também são coletados no checkout gratuito
        // (FreePayment.js já busca e renderiza CustomFieldsForm normalmente),
        // então o passo vale pra qualquer ingresso, pago ou grátis.
        setFormStep(4);
    }

    async function onCustomFieldsStepSuccess() {
        setFormStep(3);
    }

    function onProductsToEventSuccess() {
        setIsCreate(false);
        setIsEdit(false);
        setDetailVisible(event);
        setFormStep(0)
        setEventDetailTab('detail')
        setCreateDraftClick(0)
        getEvents();

    }

    function onEventPublished(eventName) {
        toast.success(`O evento "${eventName}" foi publicado com sucesso!`, {
            position: 'top-center'
        });
        setIsCreate(false);
        setIsEdit(false);
        getEvents();
    }

    function onCloseCollapse() {
        setCreateDraftClick(0);
        setWithBackButton(false)
        setIsEdit(false)
        setIsCreate(false)
        setEventDetailTab('detail')
        setDetailVisible(false)
        setFormStep(1)


        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);

            Object.values(routeParams.resume).map(el => {
                newSearchParams.delete(el)
            })

            return newSearchParams;
        });
        setEventActionError(false)
        setShowAllEvents({ ...showAllEvents, visible: false })
    }

    async function goBackFormStep(step) {
        if (step === 1) {
            await getEventBySlug({ slug: event.slug, from: true });
            setFormStep(1);

            return;
        }

        if (step === 2) {
            await getEventBySlug({ slug: event.slug, from: true });
            setFormStep(2);

            return;
        }

        if (step === 4) {
            await getEventBySlug({ slug: event.slug, from: true });
            setFormStep(4);

            return;
        }
    }

    return (
        <>
            {
                loading ?
                    <EventListSkeleton sections={[4, 3, 2]} />
                    : (
                        <>
                            {data?.now?.total > 0 || data?.next?.total > 0 || data?.expired?.total > 0 || data?.draft?.total > 0 ? (
                                <SectionsContainer>
                                    {
                                        data?.now?.total ? (
                                            <ListEventItems
                                                title='Eventos de hoje'
                                                type='now'
                                                data={data.now}
                                                dropdownLoading={dropdownLoading}
                                                onEventClick={e => setDetailVisible(e)}
                                                onDropdownAction={(e) => activeActionClicked(e)}
                                            />
                                        ) : null
                                    }

                                    {
                                        data?.draft?.total ? (
                                            <ListEventItems
                                                title='Rascunho'
                                                type='draft'
                                                data={data.draft}
                                                dropdownLoading={dropdownLoading}
                                                onEventClick={e => setDetailVisible(e)}
                                                onDropdownAction={(e) => activeActionClicked(e)}
                                            />
                                        ) : null
                                    }

                                    {
                                        data?.next?.total ? (
                                            <ListEventItems
                                                title='Próximos Eventos'
                                                type='next'
                                                data={data.next}
                                                dropdownLoading={dropdownLoading}
                                                onEventClick={e => setDetailVisible(e)}
                                                onDropdownAction={(e) => activeActionClicked(e)}
                                            />
                                        ) : null
                                    }

                                    {
                                        data?.expired?.total ? (
                                            <ListEventItems
                                                title='Finalizados'
                                                type='expired'
                                                data={data.expired}
                                                dropdownLoading={dropdownLoading}
                                                onEventClick={e => setDetailVisible(e)}
                                                onDropdownAction={(e) => activeActionClicked(e)}
                                                expired
                                            />
                                        ) : null
                                    }
                                </SectionsContainer>
                            ) : (
                                notFound &&
                                <EmptyStateCard>
                                    <NotResultDashBoard
                                        ilustration={'events'}
                                        textButton={'Criar primeiro evento'}
                                        onClick={() => createEvent()}
                                        text={'Notei que você ainda não possui eventos. Que tal criar seu primeiro evento e ter uma experiência incrível?'}
                                    />
                                </EmptyStateCard>
                            )}

                            {
                                noEstablishmentModal && (
                                    <Modal isOpen={!!noEstablishmentModal} onClose={() => setNoEstablishmentModal(false)} >
                                        <Text name='highlight' marginTop={'10px'} marginBottom={'10px'}>
                                            Você precisa ter um Estabelecimento criado para cadastrar um evento.
                                        </Text>
                                        <Button path={paths.dashboard.profile}>
                                            Criar Estabelecimento
                                        </Button>
                                    </Modal>
                                )
                            }

                            {
                                !hasProfileProducer && (
                                    <Modal isOpen={!hasProfileProducer} onClose={() => setHasProfileProducer(false)} >
                                        <Text name='highlight' marginTop={'10px'} marginBottom={'10px'}>
                                            Você precisa ter um perfil de produtor para cadastrar um evento.
                                        </Text>
                                        <Button path={paths.dashboard.profile}>
                                            Criar Perfil de Produtor
                                        </Button>
                                    </Modal>
                                )
                            }

                            {
                                showBankForm && (
                                    <Modal isOpen={showBankForm} onClose={() => setShowBankForm(false)} size='large'>
                                        <BankForm visible={showBankForm} onClose={() => setShowBankForm(false)} toast={toast} />
                                    </Modal>
                                )
                            }

                        </>

                    )
            }

            <DeleteEvent
                isDelete={isDelete}
                onSuccess={handleSucess}
                onClose={(e) => setIsDelete(e)}
            />

            <ToastContainer toasts={toasts} />

            {
                (!!isEdit || isCreate) &&
                <DashCollapse
                    visible={!!isEdit || isCreate}
                    onClose={() => onCloseCollapse()}
                >
                    {

                        eventLoading
                            ? <EventLoaderContainer>
                                <Loader />
                            </EventLoaderContainer>
                            : (
                                formStep === 1 &&
                                <EventForm
                                    isDraft={createDraftClick}
                                    setCreateDraftClick={setCreateDraftClick}
                                    edit={isEdit}
                                    onLoading={(e) => setEventLoading(e)}
                                    onSuccess={(data, from) => onEventSucces(data, from)}
                                />
                            )
                    }

                    {
                        formStep === 2 && (
                            <TicketForm
                                isDraft={createDraftClick}
                                edit={originEvent === 'edit'}
                                availableProducts={availableProducts}
                                onSuccess={(data) => onTicketSuccess(data)}
                                goBackFormStep={goBackFormStep}
                            />
                        )
                    }

                    {
                        formStep === 4 && (
                            <EventCustomFieldsStep
                                onSuccess={() => onCustomFieldsStepSuccess()}
                                goBackFormStep={goBackFormStep}
                            />
                        )
                    }

                    {
                        formStep === 3 && (
                            <ProductsToEvent
                                isDraft={createDraftClick}
                                edit={originEvent === 'edit'}
                                availableProducts={availableProducts}
                                productsPagination={productsPagination}
                                productsLoading={productsLoading}
                                onProductPaginate={onProductPaginate}
                                highlightProductId={highlightProductId}
                                onSuccess={(data) => onProductsToEventSuccess(data)}
                                goBackFormStep={() => goBackFormStep(4)}
                            />
                        )
                    }

                </DashCollapse>
            }

            {/* <Modal size='large' isOpen={!!isEdit} onClose={() => setIsEdit(false)}>
                <EventForm edit={isEdit} />
            </Modal> */}

            <DashCollapse
                visible={!!detailVisible}
                onClose={() => onCloseCollapse()}
                deleted={can(PERMISSIONS.EVENTS_DELETE) && !isCollaboration(detailVisible)}
                edit={can(PERMISSIONS.EVENTS_EDIT) && canInEvent(detailVisible, EVENT_PERMISSIONS.EDIT) && !detailEnded}
                clickedAction={(e) => activeActionClicked(e)}
                bgColor={'#F9FAFB'}
            >
                <ContainerCollapse >
                    {detailVisible && <CollaborationNotice />}
                    <Tab toogleTab={handleTabClick} selectedTab={eventDetailTab} hasTickets={hasTickets} hasProducts={hasProducts} availableProducts={availableProducts} />
                    {detailVisible && renderContent(eventDetailTab)}
                </ContainerCollapse>
            </DashCollapse>

            <DashCollapse
                visible={!!showAllEvents?.visible}
                onClose={() => onCloseCollapse()}
                widthOnDesktop={'70%'}
            >

                {showAllEvents?.visible && (
                    <ShowMoreList
                        withBackButton={withBackButton}
                        onEventClick={
                            (e) => {
                                setDetailVisible(e)
                                setWithBackButton(true)
                            }
                        }
                        onDropdownAction={(e) => activeActionClicked(e)}
                    />
                )}
            </DashCollapse>

            <Modal isOpen={collaborationEditNotice} closeButton size='small' onClose={() => setCollaborationEditNotice(false)}>
                <Column paddingTop='.5rem' paddingBottom='.5rem' paddingLeft='.5rem' paddingRight='.5rem'>
                    <Text name='highlight' color={colors.nightDark}>
                        Edição do evento
                    </Text>
                    <Text marginTop='10px' color={colors.night}>
                        A edição completa do evento ainda não está disponível por aqui. Fale com o produtor pra alterar os dados desse evento.
                    </Text>
                </Column>
            </Modal>

            {
                publishModal && (
                    <PublishModal
                        visible={publishModal}
                        data={publishModal}
                        onClose={() => setPublishModal(false)}
                        onPublished={(e) => onEventPublished(e)}
                    />
                )
            }
        </>
    )
}

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const SectionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    animation: ${fadeInUp} 0.4s ease-out;
`;

const EmptyStateCard = styled.div`
    border-radius: 12px;
    border: 1px solid ${colors.neutralDark};
    overflow: hidden;
    margin-top: 16px;
    animation: ${fadeInUp} 0.4s ease-out;
`;

const ContentDash = styled(Column)`
    width: 100%;
    height: 100vh;
    /* padding: 5px; */
    margin-top: 12px;
    ${({ notResult }) => notResult && `
        & > div {
            flex-direction: column;
        }
        & > div  > picture{
            width: 250px;
        }
        & > div > div {
                padding: 20px;
        }
    `}
`

const EventLoaderContainer = styled(FullyCentered)`
    width: 100%;
    height: 100%;
`;

const ContainerCollapse = styled.div`
    background: #F9FAFB;
`;